import angular from 'angular';
import jsBeautify from 'js-beautify';
import { chain, map } from 'lodash';

import _css from './live-demo-block.less';

module.exports = angular.module('common.components.live-demo-block', [])
.directive('liveDemoBlock', ($compile, $location) => {
  class LiveDemoBlock {
    constructor($element, $scope) {
      this.demos = [];
      this.liveSource = '';
      this.liveResultElem = $element.find('live-demo-result');
      this.iframeIsLoading = false;

      this.iframe = Boolean($element[0].getAttribute('iframe'));

      // Render the contents of this demo block into an iFrame.
      // We want the iFrame to have the same CSS and JS as our host app, so we
      // load the host app into the iFrame and then modify its contents later.
      if (this.iframe) {
        this.iframeIsLoading = true;
        this.iframeElement = angular.element(
          `<iframe class='live-demo-target' src='${$location.absUrl()}'></iframe>`
        );
        this.liveResultElem.append(this.iframeElement);

        this.iframeElement.ready(() => {
          $scope.$apply(() => {
            // Clear out all div and main elements within the page we just
            // loaded. We want to keep any scripts and CSS within body, so we
            // can't clear the whole body tag out.
            map(this.iframeElement.contents().find('body').children(), (child) => {
              if (child.tagName.toLowerCase() === 'div' ||
                  child.tagName.toLowerCase() === 'main') {
                child.remove();
              }
            });

            // Make a new <main> tag to put our content in
            this.iframeElement.contents().find('body').append('<main></main>');

            this._handleSourceUpdate();
            this.iframeIsLoading = false;
          });
        });
      }

      this.scope = $scope;

      $scope.$watch(() => this.liveSource, () => {
        this.liveSourceNumRows = this.liveSource.split('\n').length;
        this._handleSourceUpdate();
      });
    }

    registerDemo(name, source) {
      this.demos.push({
        name: name,
        source: jsBeautify.html(source),
        selected: false
      });

      if (this.demos.length === 1) {
        this.selectDemo(this.demos[0]);
      }
    }

    selectDemo(demo) {
      this.liveSource = demo.source;
      this._handleSourceUpdate();
    }

    _handleSourceUpdate() {
      this.demos.forEach((demo) => {
        demo.selected = (demo.source === this.liveSource);
      });

      if (this.iframe) {
        this.iframeElement.contents().find('main').html(this.liveSource);
      } else {
        this.liveResultElem.empty().append($compile(this.liveSource)(this.scope));
      }
    }
  }
  return {
    restrict: 'EA',
    controller: LiveDemoBlock,
    bindToController: true,
    controllerAs: 'liveDemoBlockCtrl',
    transclude: true,
    template: require('./live-demo-block.jade')()
  };
})
.directive('liveDemo', () => {
  return {
    restrict: 'EA',
    require: '^liveDemoBlock',
    template: function(elem, attrs) {
      var source = elem[0].innerHTML.trim();
      var spaces = chain(source.split('\n'))
        .map(line => line.match(/^\s+/))
        .sortBy(spaces => spaces ? spaces[0].length : 1000)
        .first();
      attrs.$set('source', source.replace(new RegExp(spaces, 'g'), ''));
      return '<div></div>';
    },
    scope: true,
    link: function(scope, elem, attrs, liveDemoBlock) {
      liveDemoBlock.registerDemo(attrs.name, attrs.source);
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/live-demo-block.js
 **/